// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lua, .sql, .python, .json {
	.hljs-keyword {
		color: var(--red-fire)
	}

	.hljs-number {
		color: var(--supernova-gold)
	}

	.hljs-built_in {
		color: var(--blue-stone)
	}
	
	.hljs-comment {
		color: var(--deep-teal)
	}

	.hljs-string {
		color: var(--jade-glow)
	}

}

.json {
	.hljs-attr {
		color: var(--jade-glow)
	}
}

.numbered-lines {
	counter-reset: lines 0;
	display: flex;
	flex-direction: column;
	padding-right: 5px;
	color: var(--dust-gray-80)
}

.numbered-lines span {
	counter-increment: lines 1;
}

.numbered-lines span::before {
	content: counter(lines)
}


.rich-text-code-block {
	display: flex;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLRichText/Visualizations/ECLRichTextCodeBlock.css"],"names":[],"mappings":"AAAA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;AAED;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB;AACD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC;AACD;;;AAGA;CACC,aAAa;AACd","sourcesContent":[".lua, .sql, .python, .json {\r\n\t.hljs-keyword {\r\n\t\tcolor: var(--red-fire)\r\n\t}\r\n\r\n\t.hljs-number {\r\n\t\tcolor: var(--supernova-gold)\r\n\t}\r\n\r\n\t.hljs-built_in {\r\n\t\tcolor: var(--blue-stone)\r\n\t}\r\n\t\r\n\t.hljs-comment {\r\n\t\tcolor: var(--deep-teal)\r\n\t}\r\n\r\n\t.hljs-string {\r\n\t\tcolor: var(--jade-glow)\r\n\t}\r\n\r\n}\r\n\r\n.json {\r\n\t.hljs-attr {\r\n\t\tcolor: var(--jade-glow)\r\n\t}\r\n}\r\n\r\n.numbered-lines {\r\n\tcounter-reset: lines 0;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tpadding-right: 5px;\r\n\tcolor: var(--dust-gray-80)\r\n}\r\n\r\n.numbered-lines span {\r\n\tcounter-increment: lines 1;\r\n}\r\n\r\n.numbered-lines span::before {\r\n\tcontent: counter(lines)\r\n}\r\n\r\n\r\n.rich-text-code-block {\r\n\tdisplay: flex;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
